import { Pipe, PipeTransform } from '@angular/core';

import { coerce, satisfies } from 'semver';

import { DeviceInformation } from '@rocksoft/mdm-sdk-v2';

import { OSSupportedPipeOptions } from './os-supported-pipe-options';

@Pipe({ name: 'os' })
export class OSSupportedPipe implements PipeTransform {
  // TODO: Figure out how we correctly detect OS running on devices
  private iOSModels = ['iPhone', 'iPad', 'iPod'];
  private macOSModels = [];
  private appleTVModels = ['AppleTV'];

  transform(apple: DeviceInformation | null | undefined, options: OSSupportedPipeOptions): boolean {
    // Variables needed to determine if OS is supported
    if (!apple?.modelName || !apple?.osVersion) {
      return false;
    }

    const coercedVersion = coerce(apple.osVersion);
    if (!coercedVersion) {
      return false;
    }

    let result = false;
    if (options.iOS && this.iOSModels.findIndex((model) => model === apple.modelName) !== -1) {
      result = result || satisfies(coercedVersion, options.iOS);
    }

    if (options.macOS && this.macOSModels.findIndex((model) => model === apple.modelName) !== -1) {
      result = result || satisfies(coercedVersion, options.macOS);
    }

    if (options.appleTV && this.appleTVModels.findIndex((model) => model === apple.modelName) !== -1) {
      result = result || satisfies(coercedVersion, options.appleTV);
    }

    return result;
  }
}
